import React from "react";

export default function About()
{
  return (
    <section className="home-text ">
      <div className="abput_home_">
        <div className="content_">
          <div className="img__"></div>
          <div className="block_100  "></div>

          <div className="right">
            <div className="block_100 hidden_mb "></div>
            <h3 className=" wow fadeInUp" >INTRODUCTION</h3>
            <p className="wow fadeInUp">Peer-to-peer, community-driven, innovative, incentivized, and decentralized blockchain-based GameFi ecosystem.</p>
            <p className="wow fadeInUp font-avenirltstd">RocChain is a newly-launched blockchain platform that lets users bridge over Rocket Raccoon (Roc) and use it for DeFi, NFTs, and more. With Rocchain, Rocket Raccoon holders can do more than simply hodl and wait for Rocket Raccoon to moon!</p>
            <div className="block_100  "></div>
            <div className="block_100 hidden_mb "></div>
            <div className="diagram__ wow fadeInUp">

              <div className="img1__">

              </div>
              <div className="line_w_">
                <div className="line line_1"></div>
                <div className="line line_2"></div>
                <div className="line line_3"></div>
              </div>
              <div className="img_items__">
                <div className=" img_items">
                  <div className="img_items__1 img_items___"></div>
                  <p>
                    Trade tokens in an instant</p>
                </div>
                <div className=" img_items">
                  <div className="img_items__2 img_items___"></div>
                  <p>Earn ROC and other tokens for free with super high interest rates.</p>
                </div>
                <div className=" img_items">
                  <div className="img_items__3 img_items___"></div>
                  <p>
                    Smart Allocations Token</p>
                </div>
              </div>
            </div>
            <div className="f__">
              <p className="wow fadeInUp">The DEX on BSC network with a two-type share system<br></br>

                Enjoy profitable yield farming and exchanging with the lowest fees in DeFi space!</p>
              <button className="reset_btn  btn_dark btn_dark_lg " >DEX</button>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container container-1400">
        <div className="wow fadeInUp">

        </div>
        <header className="sc-header">
          <h2 className="sc-header__title -medium text-capitalize wow fadeInUp">The biggest difference in finance is being special and unique.</h2>
          <p className="sc-header__excerpt wow fadeInUp">We create a place where users are valued in terms of physical exchange and money generation. Where you can participate in fair physical competition</p>
        </header>
        <div className="wow fadeInUp el__button">
          <a href="javascript;" className="btn btn--primary me-sm-4 me-2">Buy P2E token</a>
          <a href="javascript;" className="btn btn--primary">Buy Sneakers</a>
        </div>
      </div> */}

    </section>
  );
}
